// extracted by mini-css-extract-plugin
export var integrationButton = "_8x-0";